import { Paper, styled } from '../../../../base-components';
import { alpha } from '@mui/material/styles';

export const StyledPaper = styled(Paper)(({ theme }) => ({
    py: 1,
    px: 2,
    mt: 3,
    backgroundColor: alpha(theme.palette.error.main, 0.08),
    borderColor: alpha(theme.palette.error.main, 0.24),
}));
